import request from '@/utils/request'

let HospitalApi = {

  /*医院列表*/
  list(data) {
    return request._post('/shop/plus.hospital.Index/index', data);
},
/*添加医院*/
add(data) {
    return request._post('/shop/plus.hospital.Index/add', data);
},
/*修改医院*/
edit(data) {
    return request._post('/shop/plus.hospital.Index/edit', data);
},
/*删除医院*/
del(data) {
    return request._post('/shop/plus.hospital.Index/del', data);
},
/*医院详情*/
detail(data) {
  return request._post('/shop/plus.hospital.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hospital.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hospital.Setting/getSetting', data, errorback);
    },
      /*修改部分数据*/
editPart(data) {
    return request._post('/shop/plus.hospital.Index/editPart', data);
},
}
export default HospitalApi;



// WEBPACK FOOTER //
// ./src/api/hospital.js